<template>
  <div class="card widget">
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.widget {
  border-radius: 5px;
  border: 1px solid #dbdbdb;
}
.card-body {
  padding: unset;
}
</style>
